<template>
  <div
    class="service-carousel-card"
    :class="{ 'is-selected': isSelected }"
    @mouseenter="$emit('hover')"
  >
    <div class="card-info-content">
      <div class="card-toggle">
        <slot name="toggle" :is-selected="isSelected">
          <label class="switch">
            <input
              type="checkbox"
              :checked="isSelected"
              @change="$emit('toggle', $event.target.checked)"
            />
            <span class="slider round"></span>
          </label>
        </slot>
      </div>

      <div class="card-icon-section">
        <div class="icon-wrapper">
          <i :class="['card-icon', iconClass]"></i>
        </div>
      </div>

      <div class="card-content-section card-bg">
        <div class="text-center">
          <p class="fw-bold text-s service-heading">{{ serviceName }}</p>
        </div>
        <p class="card-description text-xs" v-if="description">
          {{ description }}
        </p>

        <div class="action-button">
          <slot name="action" :service-name="serviceName">
            <button
              class="read-more-btn"
              @click.stop="$emit('details')"
            >
              <i class="fa fa-info-circle"></i> Read more
            </button>
          </slot>
        </div>
      </div>
    </div>

    <div class="selection-indicator" v-if="isSelected">
      <i class="fas fa-check-circle"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceCarouselCard",
  props: {
    serviceName: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      default: "fas fa-check-circle",
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default:
        "This is the service description providing brief details about the service offered.",
    },
  },
  emits: ["toggle", "details", "hover"],
};
</script>

<style scoped>
.service-carousel-card {
  position: relative;
  width: 300px;
  height: 400px;
  border-radius: 24px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  background: rgba(248, 249, 250, 0.95);
  border: 1px solid rgba(108, 117, 125, 0.1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 
    0 10px 30px -10px rgba(0, 0, 0, 0.08),
    0 4px 12px -4px rgba(0, 0, 0, 0.04);
}
  
.service-carousel-card:hover {
  box-shadow: 
    0 1px 2px rgba(0, 0, 0, 0.1),
    0 2px 4px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
  border: 1px solid rgba(108, 117, 125, 0.2);
}

.service-carousel-card.is-selected {
  border: 2px solid var(--primary-color);
  box-shadow:
    0 1px 2px rgba(var(--primary-color-rgb, 89, 255, 116), 0.1),
    0 2px 4px rgba(var(--primary-color-rgb, 89, 255, 116), 0.08);
  transform: translateY(-2px);
}

/* .service-carousel-card.is-selected:hover {
  box-shadow:
    0 6px 12px rgba(var(--primary-color-rgb, 89, 255, 116), 0.12),
    0 12px 20px rgba(var(--primary-color-rgb, 89, 255, 116), 0.1);
  transform: translateY(-4px);
} */

.card-info-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

.card-toggle {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.card-icon-section {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  background: rgba(200, 200, 200, 0.15);
  border-radius: 16px;
  padding: 20px;
}

.icon-wrapper {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.service-carousel-card:hover .icon-wrapper {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.card-icon {
  font-size: 3rem;
  color: rgba(73, 80, 87, 0.8);
}

.card-content-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  background: white;
  padding: 20px;
  margin: 0 -20px -20px -20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.service-heading {
  margin: 0 0 8px 0;
  color: #212529;
  background: transparent;
}

.card-description {
  color: #6c757d;
  margin: 0 0 12px 0;
  line-height: 1.4;
  text-align: center;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  background: transparent;
  max-height: 4.2em;
}

.card-bg {
  background-image: url("@/assets/images/card-bg.svg");
  background-size: cover;
}

.action-button {
  width: 75%;
  margin-top: -2px;
}

.read-more-btn {
  width: 100%;
  background: var(--primary-color);
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 0.75rem;
  font-weight: 700;
  color: #212529;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.read-more-btn:hover {
  background: var(--primary-color);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
  opacity: 0.9;
}

.read-more-btn i {
  font-size: 0.7rem;
}

.selection-indicator {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 40px;
  height: 40px;
  background: rgba(var(--primary-color-rgb, 89, 255, 116), 0.2);
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  animation: pulse 2s infinite;
}

.selection-indicator i {
  color: var(--primary-color);
  font-size: 1.2rem;
}

@keyframes pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(var(--primary-color-rgb, 89, 255, 116), 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(var(--primary-color-rgb, 89, 255, 116), 0);
  }
}

@media (max-width: 768px) {
  .service-carousel-card {
    width: 280px;
    height: 380px;
  }

  .icon-wrapper {
    width: 80px;
    height: 80px;
  }

  .card-icon {
    font-size: 2.5rem;
  }
}
</style>
